import { get, post } from '~/utils/api';
import { ATL_MESSAGES } from '~/modules/add-to-list/constants/consts';
import { getUserIds } from '~/utils/cookiesUtils';

const HEADERS = {
  'X-Requested-With': 'XMLHttpRequest',
};

export class AddToListService {
  /**
   * @param {Boolean} isMcom
   */
  constructor(isMcom) {
    this.isMcom = isMcom;
    const { userGuid } = getUserIds();
    this.userGuid = userGuid;
  }

  _addToProductListURL = '/xapi/wishlist/v1/favorites';

  _getAllLists = '/xapi/wishlist/v1/lists?default=false';

  _addToList = '/xapi/wishlist/v1/lists';

  getAllLists = () => get(`${this._getAllLists}&userGuid=${this.userGuid}`, { headers: HEADERS });

  /**
   * @param {{
   *  productId: string,
   * selectedUpcId: string,
   * validationMessage: string | null,
   * }} options
   */
  addToList = async ({ productId, selectedUpcId, validationMessage }) => {
    const validationError = validationMessage && this._validate(validationMessage);
    if (validationError) {
      throw validationError;
    }

    try {
      if (selectedUpcId) {
        return await this.addToUpcList({ selectedUpcId });
      }
      return await this.addToWishList({ productId });
    } catch (e) {
      throw this.handleError(e, ATL_MESSAGES.ERROR);
    }
  };

  /**
   * @param {object} options
   * @param {string} options.productId
   */
  addToWishList = ({ productId }) => post(this._addToProductListURL, this._getPayload({ id: productId, type: 'product' }), { headers: HEADERS });

  /**
   * @param {object} options
   * @param {string} options.selectedUpcId
   */
  addToUpcList = ({ selectedUpcId }) => post(`${this._addToList}/items`, this._getPayload({ id: selectedUpcId, type: 'upc' }), { headers: HEADERS });

  /**
   * @param {object} options
   * @param {string} options.listGuid
   * @param {string} options.selectedUpcId
   */
  addToCustomList = async ({ listGuid, selectedUpcId }) => {
    try {
      const url = `${this._addToList}/${listGuid}/items?userGuid=${this.userGuid}`;
      return await post(url, this._getPayload({ id: selectedUpcId, type: 'upc' }), { headers: HEADERS });
    } catch (e) {
      throw this.handleError(e, ATL_MESSAGES.SLIDEOUT_ERROR);
    }
  };

  /**
   * @param {{
   * response?: Object,
   * message?: string,
   * }} error
   * @param {string} message
   */

  handleError(error, message) {
    return error.response ? Error(message) : Error(error.message || message);
  }

  /**
   * @param {string} validationMessage
   */
  _validate(validationMessage) {
    if (!this.isMcom) {
      return new Error(validationMessage);
    }
    if (validationMessage === ATL_MESSAGES.SIZE_COLOR_NOT_AVAILABLE) {
      return new Error(validationMessage);
    }
    if (validationMessage === ATL_MESSAGES.SIZE_COLOR_TYPE_NOT_AVAILABLE) {
      return new Error(validationMessage);
    }
    return null;
  }

  /**
   * @param {string} id
   * @param {string} type
   * @return {ATLListObject}
   */

  _createListObject(id, type) {
    return {
      items: [
        {
          [type]: {
            id,
          },
          qtyRequested: 1, // TODO: Add quantity,
        },
      ],
    };
  }

  /**
   * @return {ATLUser | {}} obj
   */
  _createUserObject() {
    const user = {};
    if (this.userGuid) {
      user.guid = this.userGuid;
    }
    return user;
  }

  /**
   * Create payload for add to list xapi.
   * Is used for both product level add to wishlist (new functionality) and upc level (production)
   * @param {object} options
   * @param {string} options.id
   * @param {string} options.type
   * @return ATLPayload
   */
  _getPayload({ id, type }) {
    return {
      CustomerList: {
        list: [this._createListObject(id, type)],
        user: this._createUserObject(),
      },
    };
  }
}

export default AddToListService;
